import axios from "axios";
import { API_BASENAME } from "../Constant";

//https://stg-rygplus.lumata.com/server_restapi/getMembershipInformation
const getMembershipInfo = async (identifier,programName) => {
    const url = API_BASENAME + "/getMembershipInformation";
    let requestBody = {
        "identifier": identifier,
        "membershipprogram": programName
    }
    const res = await axios.post(url, requestBody);
    // console.log("Membership Info Response:", res);    
    return res.data;
};
//https://stg-rygplus.lumata.com/server_restapi/getSubscriberAchievements
const getSubscriberAchievements = async (identifier) => {
    const url = API_BASENAME + "/getSubscriberAchievements";
    let requestBody = {
        "identifier": identifier
    }
    const res = await axios.post(url, requestBody);
    // console.log("getSubscriberAchievements Response:", res);
    return res.data;
};

export { getMembershipInfo ,getSubscriberAchievements};